import React, { useContext } from 'react'
import isEmpty from 'lodash/isEmpty'
import Box from '@material-ui/core/Box'
import noReminder from '../../../../../../assets/images/cashflow_event_image.png'

import { CardContent, CardFooter, CardHeading } from '../../../../components/layout/Card'
import { Button } from '../../../../components/Button'
import { RemindersContext } from '../../context'
import { Reminder } from './Reminder'
import { CREATE_FORM } from '../Form/formModes'

export const Index = () => {
  return (
    <>
      <CardHeading></CardHeading>
      <CardContent className='wealth-manager-reminders__list'>
        <RemindersContainer />
      </CardContent>
      <Actions />
    </>
  )
}

const RemindersContainer = () => {
  const { state: { reminders, isLoading } } = useContext(RemindersContext)

  if (isLoading) {
    return <Loading />
  } else if (isEmpty(reminders)) {
    return <NoReminders />
  } else {
    const RemindersList = reminders.map((reminder, idx) =>
      <Reminder key={idx} reminder={reminder} />
    )
    return (
      <>
        <ReminderListHeading />
        {RemindersList}
      </>
    )
  }
}

const ReminderListHeading = () => {
  return (
    <Box
      display='flex'
      justifyContent='space-between'
      className='wealth-manager-reminders__reminder__heading'
    >
      <Box className='wealth-manager-reminders__reminder__description'>
        <p>Description</p>
      </Box>
      <Box className='wealth-manager-reminders__reminder-dates'>
        <Box className='wealth-manager-reminders__reminder__remind-date'>
          <p>Reminder date</p>
        </Box>
        <Box className='wealth-manager-reminders__reminder__due'>
          <p>Due date</p>
        </Box>
      </Box>
    </Box>
  )
}

const Loading = () => {
  return (
    <Box
      className='wealth-manager-reminders__no-reminder'
    >
      <img src={noReminder} alt='No Reminders' />
      <p>Please sit back and relax while we fetch your reminders</p>
    </Box>
  )
}
export const NoReminders = () => {
  return (
    <Box
      className='wealth-manager-reminders__no-reminder'
      textAlign='center'
    >
      <img src={noReminder} alt='No Reminders' />
      <p>You don't have anything coming up, You can sit back and relax...</p>
    </Box>

  )
}

const Actions = () => {
  const {
    actions: { goToForm },
    state: { isLoading }
  } = useContext(RemindersContext)

  if (isLoading) {
    return null
  }

  return (
    <CardFooter className='wealth-manager-reminders__actions'>
      <Button
        primary
        trackAs='Reminder: Add Reminder'
        onClick={goToForm(CREATE_FORM)}
      >
        Add Reminder
      </Button>
    </CardFooter>
  )
}
